import {axiosInstance} from './axiosConfig';
import {handleRequestWithAuth} from './refreshService';

async function check(payload: {routes: string[]} | {model: string}, count: number): Promise<boolean[]> {
    return handleRequestWithAuth(async () => {
        const {data} = await axiosInstance.post('access-check/', payload);
        if (!Array.isArray(data.allowed) || data.allowed.length !== count ||
            data.allowed.some((value: unknown) => typeof value !== 'boolean')) {
            throw new Error('Respuesta de autorización inválida');
        }
        return data.allowed;
    });
}
export const checkRouteAccess = (routes: string[]) => check({routes}, routes.length);
export const checkModelAccess = (model: string) => check({model}, 4);
